export default "__VITE_ASSET__BG7GL90G__"